import React, { FC, type ReactElement } from 'react';
import moment, { Moment } from 'moment';

import getClassName from 'src/common/utils/getClassName';
import classNames from 'classnames';
import { MOMENT_FORMAT } from '../../../common/constants';
import s from './DateTime.module.scss';

// TODO: refactor so that this is just a structural wrapper, and takes two children,
// which are displayed in the requisite positions.
// The polymorphism of how it treats moments vs strings vs components isn't easy
// to follow.

type Props = {
  formatString?: string;
  title?: string;
  departDateTime?: Moment | ReactElement | string;
  returnDateTime?: Moment | ReactElement | string;
  classNameModifier?: string;
  departHeading?: string;
  returnHeading?: string;
  withSmallLabels?: boolean;
};

const DateTime: FC<Props> = ({
  title,
  departDateTime,
  returnDateTime,
  formatString = MOMENT_FORMAT.DATE,
  classNameModifier = '',
  departHeading = 'Depart',
  returnHeading = 'Return',
  withSmallLabels = false,
}) => (
  <>
    {title && (
      <h3 className={s.subTitle}>
        {title}
      </h3>
    )}
    <dl className={s.values}>
      {departHeading && (
        <dt className={getClassName(s, 'term', classNames('depart', classNameModifier, { withSmallLabels }))}>
          {departHeading}
        </dt>
      )}
      <dd className={getClassName(s, 'description', classNames('depart', classNameModifier))}>
        {moment.isMoment(departDateTime)
          ? (
            <time
              dateTime={departDateTime.format(MOMENT_FORMAT.VALUE)}
              data-test="depart-date-label"
            >
              {departDateTime.format(formatString)}
            </time>
          )
          : departDateTime}
      </dd>
      {returnHeading && (
        <dt className={getClassName(s, 'term', classNames('return', classNameModifier, { withSmallLabels }))}>
          {returnHeading}
        </dt>
      )}
      <dd className={getClassName(s, 'description', classNames('return', classNameModifier))}>
        {moment.isMoment(returnDateTime)
          ? (
            <time
              dateTime={returnDateTime.format(MOMENT_FORMAT.VALUE)}
              data-test="return-date-label"
            >
              {returnDateTime.format(formatString)}
            </time>
          )
          : returnDateTime}
      </dd>
    </dl>
  </>
);
export default DateTime;
